import { Container } from "@mui/material";
import React from "react";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import Terms from "../components/common/Terms";
import '../Style/Theme/index.css';
// import '../Style/Theme/index.css';

export default function TermsAndConditions() {
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={11} />
        <IntroCard
          title="Terms & Conditions"
          subtitle="Please read these terms & condition carefully."
          img="/assets/terms.svg"
        />
        <Terms />
      </Container>
    </>
  );
}
